import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
    advancedButton: {
        fontSize: '13px',
        cursor: 'pointer'
    },
    advancedActive: {
        transform: 'rotateZ(180deg)'
    }
}))